import {apiurl} from '@/services/config'

const API_URL = apiurl + '/backoffice/tokensms'

export const SMStokenService = {
    listdenom,
    doCreateOrder,
    listOrders,
    OrderById,
    Historitoken
}

async function listdenom () {
    const response = await fetch(API_URL+'/denom', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    })
    return await handleResponse(response)
}
async function Historitoken (opt) {
    console.log(opt)
    var sort="id"
    var sorder="ASC"
    if(opt.sortBy){
        console.log(opt.sortBy)
    }
    if(opt.sortDesc){
        if(opt.sortDesc[0]){
            sorder="DESC"
        }
    }
    if(opt.itemsPerPage<0){
        opt.itemsPerPage=10000
    }
    let page=opt.page-1;
    let sorting=sort+","+sorder
    const response = await fetch(API_URL+'/history?awal='+opt.awal+"&akhir="+opt.akhir+'&page='+page+'&size='+opt.itemsPerPage+"&sort="+sorting, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    })
    return await handleResponse(response)
}

async function listOrders (opt) {
    console.log(opt)
    var sort="id"
    var sorder="ASC"
    if(opt.sortBy){
        console.log(opt.sortBy)
    }
    if(opt.sortDesc){
        if(opt.sortDesc[0]){
            sorder="DESC"
        }
    }
    if(opt.itemsPerPage<0){
        opt.itemsPerPage=10000
    }
    let page=opt.page-1;
    let sorting=sort+","+sorder
    const response = await fetch(API_URL+'/order?awal='+opt.awal+"&akhir="+opt.akhir+'&page='+page+'&size='+opt.itemsPerPage+"&sort="+sorting, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    })
    return await handleResponse(response)
}

async function OrderById (id) {
    const response = await fetch(API_URL+'/order/'+id, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    })
    return await handleResponse(response)
}

async function doCreateOrder (postdata) {
    const response = await fetch(API_URL+'/order', {
        method: 'POST',
        body: JSON.stringify({ postdata }.postdata),
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    })
    return await handleResponse(response)
}


async function handleResponse (response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text)

        if (!data.success) {
            if (response.status === 401) {
                console.log("CALL LOGOUT");
                localStorage.setItem('token',null);
                localStorage.clear();
                location.reload(true)
            }
            const error = (data && data.msg) || response.statusText
            return Promise.reject(error)
        }
        return data
    })
}
